
export default {
  'Create end event': 'Crear evento de fin',
  'Create start event': 'Crear Evento de Inicio',
  'Activate hand tool': 'Activar la herramienta manual',
  'Activate lasso tool': 'Herramienta lazo',
  'Activate create/remove space tool': 'Activar la herramienta crear/eliminar espacio',
  'Activate global connect tool': 'Activar la herramienta de conexión global',
  'Create intermediate/boundary event': 'Crear evento intermedio/límite',
  'Create gateway': 'Crear puerta de enlace',
  'Create task': 'Crear Tarea',
  'Create expanded sub-process': 'Crear subproceso expandido',
  'Create data object reference': 'Crear referencia de objeto de datos',
  'Create data store reference': 'Crear referencia de almacen de datos',
  'flow elements must be children of pools/participants':'Los elementos de flujo deben ser hijos de grupos/participantes.',
  'Create pool/participant': 'Crear grupo/participante',
  'Create group': 'Crear grupo',
  'Documentation': 'Documentacion',
  'Collaboration': 'colaboracion',
  'Process': 'PROCESO',
  'Start Event': 'Evento de Inicio',
  'Intermediate Throw Event': 'Evento de Lanzamiento Intermedio',
  'End Event': 'Evento de Fin',
  'Exclusive Gateway': 'Puerta de enlace exclusiva',
  'Task': 'Tarea',
  'Expanded Sub Process': 'Subproceso ampliado',
  'Data Object Reference': 'Referencia de Objeto de datos',
  'Data object reference': 'Referencia de Objeto de datos',
  'Data Store Reference': 'Referencia del almacen de datos',
  'Data store reference': 'Referencia del almacen de datos',
  'Participant': 'Participante',
  'Group': 'grupo',
  'Align elements': 'Alinear elementos',

  'Change element': 'Cambiar elemento',
  'Connect to other element': 'Conectar a otro elemento',
  'Delete': 'Eliminar',
  'Add text annotation': 'Añadir nota',
  'Append intermediate/boundary event': 'añadir evento intermedio/límite',
  'Append task': 'añadir tarea',
  'Append gateway': 'añadir puerta de enlace',
  'Append end event': 'añadir evento de fin',
  'Add lane above': 'Añadir carril arriba',
  'Divide into two lanes': 'Dividir en dos carriles',
  'Divide into three lanes': 'Dividir en tres carriles',
  'Add lane below': 'Añadir carril debajo',

  'Element documentation': 'Documentacion del elemento',
  'Name': 'Nombre',
  'Participant ID': 'ID del Participante',
  'Process ID': 'ID del proceso',
  'Process name': 'Nombre del Proceso',
  'Executable': 'Ejecutable',
  'Parallel gateway': 'Puerta de Enlace Paralela',
  'Parallel Gateway': 'Puerta de Enlace Paralela',
  'Inclusive gateway': 'Puerta de Enlace Inclusiva',
  'Complex gateway': 'Puerta de Enlace Compleja',
  'Event-based gateway': 'Puerta de Enlace Basada en Eventos',  
  'Event Based Gateway': 'Puerta de Enlace Basada en Eventos',  
  'Process documentation': 'Documentacion del Proceso',
  'Exclusive gateway': 'Puerta de Enlace Exclusiva',
  'Multiple elements are selected. Select a single element to edit its properties.': 'Se seleccionan varios elementos. Seleccione un solo elemento para editar sus propiedades.',
  'Append message intermediate catch event': 'Añadir evento intermedio de captura de mensaje', 
  'Append receive task': 'Añadir Tarea Recibida', 
  'Extension properties': 'Propiedades de extension', 
  'Outputs': 'Salidas', 
  'Create': 'crear',
  'Start event': 'Evento de Inicio',
  'Gateways': 'Puertas de Enlace',
  'Tasks': 'Tareas',
  'Sub-processes': 'Sub-Procesos',
  'Events': 'Eventos',
  'Data': 'Datos',
  'Participants': 'Participantes',
  'User task': 'Tareas de Usuario',
  'User Task': 'Tareas de Usuario',
  'Service task': 'Tareas de Servicio',
  'Service Task': 'Tareas de Servicio',
  'Business Rule Task': 'Tarea de regla de negocio',
  'Business rule task': 'Tarea de regla de negocio',
  'Script Task': 'Tarea de script',
  'Script task': 'Tarea de script',
  'Call Activity': 'Actividad de llamadas',
  'Call activity': 'Actividad de llamadas',
  'Transaction': 'Transaccion',
  'Event Sub Process': 'Subproceso de evento',
  'Event sub-process': 'Sub-proceso de evento',
  'Collapsed Sub Process': 'Subproceso colapsado',
  'Sub-process (collapsed)': 'Sub-proceso (colapsado)',
  'Expanded Sub Process': 'Subproceso expandido',
  'Sub-process (expanded)': 'Sub-proceso (expandido)',
  'Intermediate throw event': 'Evento de Lanzamiento Intermedio',
  'Boundary event': 'Evento límite',
  'End event': 'Evento de Fin',
  'Message Start Event': 'Evento de inicio de Mensaje',
  'Message start event': 'Evento de inicio de Mensaje',
  'Timer start event': 'Evento de inicio de temporizador',
  'Timer Start Event': 'Evento de inicio de temporizador',
  'Conditional Start Event': 'Evento de inicio condicional',
  'Conditional start event': 'Evento de inicio condicional',
  'Signal start event': 'Evento de inicio de señal',
  'Signal Start Event': 'Evento de inicio de señal',
  'Message Intermediate Catch Event': 'Evento de captura intermedia de mensajes',
  'Message intermediate catch event': 'Evento de captura intermedia de mensajes',
  'Message Intermediate Throw Event': 'Evento de lanzamiento intermedio de mensajes',
  'Message intermediate throw event': 'Evento de lanzamiento intermedio de mensajes',
  'Timer Intermediate Catch Event': 'Evento de captura intermedia del temporizador',
  'Append timer intermediate catch event': 'Añadir evento de captura intermedia del temporizador',
  'Timer intermediate catch event': 'Evento de captura intermedia del temporizador',
  'Escalation Intermediate Throw Event': 'Evento de lanzamiento intermedio de escalada',
  'Escalation intermediate throw event': 'Evento de lanzamiento intermedio de escalada',
  'Conditional Intermediate Catch Event': 'Evento de captura intermedia condicional',
  'Conditional intermediate catch event': 'Evento de captura intermedia condicional',
  'Append conditional intermediate catch event': 'Añadir evento de captura intermedia condicional',
  'Link Intermediate Catch Event': 'Evento de captura intermedia de enlace',
  'Link intermediate catch event': 'Evento de captura intermedia de enlace',
  'Link Intermediate Throw Event': 'Evento de lanzamiento intermedio de enlace',
  'Link intermediate throw event': 'Evento de lanzamiento intermedio de enlace',
  'Compensate Intermediate Throw Event': 'Compensar evento de lanzamiento intermedio',
  'Compensation intermediate throw event': 'Compensar evento de lanzamiento intermedio',
  'Signal Intermediate Catch Event': 'Evento de captura intermedia de señal',
  'Signal intermediate catch event': 'Evento de captura intermedia de señal',
  'Append signal intermediate catch event': 'Añadir evento de captura intermedia de señal',
  'Signal Intermediate Throw Event': 'Evento de lanzamiento intermedio de señal',
  'Signal intermediate throw event': 'Evento de lanzamiento intermedio de señal',
  'Message End Event': 'Evento de fin de mensaje',
  'Message end event': 'Evento de fin de mensaje',
  'Escalation End Event': 'Evento final de escalada',
  'Escalation end event': 'Evento final de escalada',
  'Error End Event': 'Evento de fin de error',
  'Error end event': 'Evento de fin de error',
  'Cancel end event': 'Cancelar de fin',
  'Compensate End Event': 'Compensar evento final',
  'Compensation end event': 'Compensar evento final',
  'Signal End Event': 'Evento de fin de señal',
  'Signal end event': 'Evento de fin de señal',
  'Terminate End Event': 'Evento de finalización de terminación',
  'Terminate end event': 'Evento de finalización de terminación',
  'Message boundary event': 'Evento de límite de mensaje',
  'Timer boundary event': 'Evento de límite del temporizador',
  'Escalation boundary event': 'Evento de límite de escalamiento',
  'Conditional boundary event': 'Evento de límite condicional',
  'Error boundary event': 'Evento de límite de error',
  'Signal boundary event': 'Evento de límite de señal',
  'Compensation boundary event': 'Evento de límite de compensación',
  'Cancel boundary event': 'Evento de límite de Cancelacion',
  'Message boundary event (non-interrupting)': 'Evento de límite de mensaje (sin interrupción)',
  'Timer boundary event (non-interrupting)': 'Evento de límite del temporizador (sin interrupción)',
  'Escalation boundary event (non-interrupting)': 'Evento de límite de escalamiento (sin interrupción)',
  'Conditional boundary event (non-interrupting)': 'Evento de contorno condicional  (sin interrupción)',
  'Signal boundary event (non-interrupting)': 'Evento de límite de señal (sin interrupción)',
  'Expanded pool/participant': 'Participante',
  'Empty pool/participant': 'Participante Simple',
  'Value': 'Valor',
  '<empty>': 'Vacio',
  'Delete item': 'Eliminar Item',
  'Toggle section': 'Eliminar Item',
  'Append element': 'Añadir elemento',
  'Assignment': 'Asignación',
  'Assignee': 'Apoderado',
  'Candidate groups': 'Grupos candidatos',
  'Candidate users': 'Usuarios candidatos',
  'Due date': 'Fecha de vencimiento',
  'Follow up date': 'Fecha de seguimiento',
  'Local variable name': 'Nombre de variable local',
  'Variable assignment value': 'Valor de asignación de variable',
  'Process variable name': 'Nombre de la variable de proceso',
  'Type': 'Tipo',
  'Key': 'Llave',
  'Retries': 'Reintentos',
  'Implementation': 'Implementacion',
  'Section contains data': 'Esta seccion contiene datos',
  'Propagate all parent process variables': 'Propagar todas las variables del proceso principal',
  'Propagate all child process variables': 'Propagar todas las variables del proceso hijo',
  'If turned on, all variables from the parent process instance will be propagated to the child process instance.': 'Si está activado, todas las variables de la instancia del proceso principal se propagarán a la instancia del proceso secundario.',
  'Otherwise, only variables defined via input mappings will be propagated.': 'De lo contrario, solo se propagarán las variables definidas mediante asignaciones de entrada.',
  'If turned on, all variables from the child process instance will be propagated to the parent process instance.': 'Si está activado, todas las variables de la instancia del proceso secundario se propagarán a la instancia del proceso principal.',
  'Otherwise, only variables defined via input mappings will be propagated.': 'De lo contrario, solo se propagarán las variables definidas mediante asignaciones de entrada.',
  'Otherwise, only variables defined via output mappings will be propagated.': 'De lo contrario, solo se propagarán las variables definidas mediante asignaciones de salida.',
  'Global message reference': 'Referencia de mensaje global',
  'Global signal reference': 'Referencia de señal global',
  'Create element': 'Crear elemento',
  'Collection': 'Recopilación',
  'Send task':'Enviar Tarea',
  'Send Task':'Enviar Tarea',
  'Receive task': 'Recibir Tarea',
  'Receive Task': 'Recibir Tarea',
  'Manual task': 'Tarea manual',
  'Manual Task': 'Tarea manual',
  'Condition': 'Tarea manual',
  'Timer': 'Temporizador',
  'Date': 'Fecha',
  'Duration': 'Duración',
  '<none>': 'Ninguno(a)',
  'A specific point in time defined as ISO 8601 combined date and time representation.': 'Un momento específico en el tiempo definido como representación combinada de fecha y hora según ISO 8601.',
  'How to configure a timer': '  ', 
  'UTC time': 'hora UTC', 
  'UTC plus 2 hours zone offset': 'UTC más 2 horas de compensación de zona', 
  'A cycle defined as ISO 8601 repeating intervals format, or a cron expression.': 'Un ciclo definido como formato de intervalos de repetición ISO 8601 o una expresión cron.', 
  'every 10 seconds, up to 5 times': 'cada 10 segundos, hasta 5 veces', 
  'every day, infinitely': 'todos los días, infinitamente', 
  'every hour on the hour from 9-5 p.m. UTC Monday-Friday': 'cada hora en punto de 9 a 5 p.m. UTC de lunes a viernes', 

};
